import { render, staticRenderFns } from "./EducatorListRoles.vue?vue&type=template&id=d84bf908&"
import script from "./EducatorListRoles.vue?vue&type=script&lang=js&"
export * from "./EducatorListRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports